module.exports = __webpack_public_path__ + "static/form-4cc5ed8ae53faac0658c5a3b2e8c74d2.png";